export enum Routes {
  // base url
  BASE_URL = 'https://lead-app.ir/api/wholesaler/v1/',
  // BASE_URL = 'https://lead-app.ir/api/wholesaler/v2/',

  // auth
  INSERT_MOBILE = 'send-mobile',
  VERIFY_CODE = 'login',
  LOGOUT = 'logout',

  // user
  USER = 'user',
  PROVINCES = 'provinces',
  CITIES = 'city',
  EDIT_USER = 'profile',

  // home
  HOME = 'home',
  VERSION = 'version',
  ABOUT_US = 'about-us',
  CONTACT_US = 'contact-us',

  // prefixes
  COMPANY_PREFIX = 'company',
  CATEGORY_PREFIX = 'category',
  PRODUCT_PREFIX = 'product',

  // category
  CATEGORY = 'categories',

  // product
  PRODUCTS = 'products',
  FAVORITE = 'favorite',

  // cart
  CART = 'cart',
  CHANGE_CART_ITEM = 'add-to-cart',
  CART_COMPLETION = 'cart/complete',
  REMOVE_CART_ITEM = 'cart/remove-item',
  REMOVE_CART = 'cart/clear',

  // factor
  FACTORS = 'invoices',
  FACTOR = 'invoices',
}
